import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../features/tasks/TasksApi";
import TaskItem from "./TaskItem";

export default function TaskList() {
	const { data: tasks, isLoading, isError } = useGetTasksQuery();
	const unSelectedProjectIds = useSelector(state => state.unSelectedProjects) || [];
	const { searchText } = useSelector(state => state.filter) || {};


	let content = null;
	if (isLoading) {
		content = <div>Loading...</div>;
	}
	else if (!isLoading && isError) {
		content = <div>There was an error</div>;
	}
	else if (!isLoading && !isError && tasks?.length === 0) {
		content = <div>No tasks found!</div>;
	}
	else if (!isLoading && !isError && tasks?.length > 0) {
		let filteredTasks = tasks.filter(t => !unSelectedProjectIds.includes(t.project.id));
		if (searchText !== "" && searchText?.length > 0) {
			console.log("search: ", searchText);
			filteredTasks = filteredTasks.filter(t => t.taskName.toLowerCase().includes(searchText.toLowerCase()));
		}

		content = filteredTasks.map(task => <TaskItem key={task.id} task={task} />);
	}
	else {
		content = <div>Something went wrong!</div>
	}

	return (
		<div className="lws-task-list">
			{content}
		</div>
	);
}
